import * as React from 'react'
import './styles.css'
import '../Overview/styles.css'
import TrademarkText from '../../ui/TrademarkText'
import employeeExperienceImg from '../../../assets/imgs/overview/employee-experience.svg'

const WorkforcePathways = () => {
  return (
    <section className='overview-section workforce-pathways-section'>
      <div className='box'>
        <div className='workforce-pathways-grid'>
          <div className='workforce-pathways-content'>
            <h2 className='workforce-pathways-title'>
              Turn Workforce Pathways Into Measurable Intelligence
            </h2>
            <p className='workforce-pathways-copy'>
              Provide leadership and workforce stakeholders with clear,
              data-driven pathways based on real skills, organizational demand,
              and future workforce requirements.
            </p>
            <p className='workforce-pathways-copy'>
              <TrademarkText>Pod Adaptive Intelligence Engine™</TrademarkText>{' '}
              continuously refines career pathways, reskilling
              recommendations, and workforce planning insights - supporting
              retention, mobility, and long-term workforce resilience.
            </p>
          </div>

          <div className='workforce-pathways-visual overview-tile-container gradient-top-right box-relative-gradient'>
            <img
              src={employeeExperienceImg}
              alt='Employee Experience'
              className='elements workforce-pathways-image'
            />
            <div className='description-wrapper'>
              <div className='description-title'>Employee Experience</div>
              <div className='description-subtitle'>
                Clear pathways for career growth.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WorkforcePathways
